export default "__VITE_ASSET__a580cc02__"